import { LocalizationProvider } from '@scuf/localization';
import * as React from 'react';
import TranslationsUtility from '../translations/TranslationsUtility';

const translations = TranslationsUtility.getTransations();

export const HOCLocalization = <P extends object>(
  Component: React.ComponentType<P> | React.FC<P>
) => (props: P) => (
  <LocalizationProvider translations={translations}>
    <Component {...(props as P)} />
  </LocalizationProvider>
);
